import {IDropdownItem} from "./index";

export enum Days {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export const weekDaysInHebrew: Record<Days, string> = {
  [Days.SUNDAY]: 'ראשון',
  [Days.MONDAY]: 'שני',
  [Days.TUESDAY]: 'שלישי',
  [Days.WEDNESDAY]: 'רביעי',
  [Days.THURSDAY]: 'חמישי',
  [Days.FRIDAY]: 'שישי',
  [Days.SATURDAY]: 'שבת',
}

export const daysMapping: Record<number, Days> = {
  7: Days.SUNDAY,
  1: Days.MONDAY,
  2: Days.TUESDAY,
  3: Days.WEDNESDAY,
  4: Days.THURSDAY,
  5: Days.FRIDAY,
  6: Days.SATURDAY,
}

export const hours: IDropdownItem[] = [
	{"name": "00:00", "value": "00:00", numericValue: 0},
	{"name": "00:30", "value": "00:30", numericValue: 0.5},
	{"name": "01:00", "value": "01:00", numericValue: 1},
	{"name": "01:30", "value": "01:30", numericValue: 1.5},
	{"name": "02:00", "value": "02:00", numericValue: 2},
	{"name": "02:30", "value": "02:30", numericValue: 2.5},
	{"name": "03:00", "value": "03:00", numericValue: 3},
	{"name": "03:30", "value": "03:30", numericValue: 3.5},
	{"name": "04:00", "value": "04:00", numericValue: 4},
	{"name": "04:30", "value": "04:30", numericValue: 4.5},
	{"name": "05:00", "value": "05:00", numericValue: 5},
	{"name": "05:30", "value": "05:30", numericValue: 5.5},
	{"name": "06:00", "value": "06:00", numericValue: 6},
	{"name": "06:30", "value": "06:30", numericValue: 6.5},
	{"name": "07:00", "value": "07:00", numericValue: 7},
	{"name": "07:30", "value": "07:30", numericValue: 7.5},
	{"name": "08:00", "value": "08:00", numericValue: 8},
	{"name": "08:30", "value": "08:30", numericValue: 8.5},
	{"name": "09:00", "value": "09:00", numericValue: 9},
	{"name": "09:30", "value": "09:30", numericValue: 9.5},
	{"name": "10:00", "value": "10:00", numericValue: 10},
	{"name": "10:30", "value": "10:30", numericValue: 10.5},
	{"name": "11:00", "value": "11:00", numericValue: 11},
	{"name": "11:30", "value": "11:30", numericValue: 11.5},
	{"name": "12:00", "value": "12:00", numericValue: 12},
	{"name": "12:30", "value": "12:30", numericValue: 12.5},
	{"name": "13:00", "value": "13:00", numericValue: 13},
	{"name": "13:30", "value": "13:30", numericValue: 13.5},
	{"name": "14:00", "value": "14:00", numericValue: 14},
	{"name": "14:30", "value": "14:30", numericValue: 14.5},
	{"name": "15:00", "value": "15:00", numericValue: 15},
	{"name": "15:30", "value": "15:30", numericValue: 15.5},
	{"name": "16:00", "value": "16:00", numericValue: 16},
	{"name": "16:30", "value": "16:30", numericValue: 16.5},
	{"name": "17:00", "value": "17:00", numericValue: 17},
	{"name": "17:30", "value": "17:30", numericValue: 17.5},
	{"name": "18:00", "value": "18:00", numericValue: 18},
	{"name": "18:30", "value": "18:30", numericValue: 18.5},
	{"name": "19:00", "value": "19:00", numericValue: 19},
	{"name": "19:30", "value": "19:30", numericValue: 19.5},
	{"name": "20:00", "value": "20:00", numericValue: 20},
	{"name": "20:30", "value": "20:30", numericValue: 20.5},
	{"name": "21:00", "value": "21:00", numericValue: 21},
	{"name": "21:30", "value": "21:30", numericValue: 21.5},
	{"name": "22:00", "value": "22:00", numericValue: 22},
	{"name": "22:30", "value": "22:30", numericValue: 22.5},
	{"name": "23:00", "value": "23:00", numericValue: 23},
	{"name": "23:30", "value": "23:30", numericValue: 23.5},
]
